import axios from "axios";
import { base_url, config } from "../../utils/axiosConfig";

axios.interceptors.request.use(
  (config) => {
    const getTokenFromLocalStorage = localStorage.getItem("user_website")
      ? JSON.parse(localStorage.getItem("user_website"))
      : null;
    const token = getTokenFromLocalStorage?.token || "";
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const register = async (userData) => {
  const response = await axios.post(`${base_url}user/register`, userData);
  if (response.data) {
    return response.data;
  }
};

const login = async (user) => {
  const response = await axios.post(`${base_url}v1/user/user-login`, {
    email: user,
  });
  // if (response.data) {
  //   localStorage.setItem("user", JSON.stringify(response.data));
  // }
  return response.data;
};

const endUserLogin = async (user) => {
  const response = await axios.post(`${base_url}user/endUserLogin`, {
    email: user,
  });
 
  return response.data;
};

const channeLogin = async (userData) => {
  const response = await axios.post(`${base_url}user/partnerLogin`, userData);
 
  return response.data;
};


const otp = async (user) => {
  const response = await axios.post(
    `${base_url}v1/user/user-verifyLogin`,
    user
  );
  if (response.data) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }
  return response.data;
};

const endOtp = async (user) => {
  const response = await axios.post(
    `${base_url}user/endUserLoginVerify`,
    user
  );
  if (response.data) {
    localStorage.setItem("user_website", JSON.stringify(response.data));
  }
  return response.data;
};

const channelOtp = async (channelOtpData) => {
  const response = await axios.post(
    `${base_url}user/partnerLoginVerify`,
    channelOtpData
  );
  if (response.data) {
    localStorage.setItem("user_website", JSON.stringify(response.data));
  }
  return response.data;
};


const registerAccount = async (userData) => {
  const response = await axios.post(`${base_url}user/register`, userData);
  if (response.data) {
    return response.data;
  }
};

const endUserRegister = async (userData) => {
  const response = await axios.post(`${base_url}user/createEndUser`, userData);
  if (response.data) {
    return response.data;
  }
};

const loginAccount = async (userData) => {
  const response = await axios.post(`${base_url}account/login`, userData);
  // if (response.data) {
  //   localStorage.setItem("customer", JSON.stringify(response.data));
  // }
  return response.data;
};

const getUserWislist = async () => {
  const response = await axios.get(`${base_url}wishlist/get`, config);
  if (response.data) {
    return response.data;
  }
};

const addToCart = async (cartData) => {
  const response = await axios.post(`${base_url}user/cart`, cartData, config);
  if (response.data) {
    return response.data;
  }
};

const getCart = async (data) => {
  const response = await axios.get(`${base_url}user/cart`, data);
  if (response.data) {
    return response.data;
  }
};

const removeProductFromCart = async (data) => {
  const response = await axios.delete(
    `${base_url}user/delete-product-cart/${data.id}`,
    data.config2
  );
  if (response.data) {
    return response.data;
  }
};

const updateProductFromCart = async (cartDetail) => {
  const response = await axios.delete(
    `${base_url}user/update-product-cart/${cartDetail.cartItemId}/${cartDetail.quantity}`,
    config
  );
  if (response.data) {
    return response.data;
  }
};

const createOrder = async (orderDetail) => {
  const response = await axios.post(
    `${base_url}user/cart/create-order/`,
    orderDetail,
    config
  );
  if (response.data) {
    return response.data;
  }
};

const getUserOrders = async () => {
  const response = await axios.get(`${base_url}user/getmyorders`, config);
  if (response.data) {
    return response.data;
  }
};

const updateUser = async (data) => {
  const response = await axios.put(
    `${base_url}user/edit-user`,
    data.data,
    data.config2,
    config
  );
  if (response.data) {
    return response.data;
  }
};

const forgotPasswordToken = async (data) => {
  const response = await axios.post(`${base_url}user/forgot-password-token`, data);
  if (response.data) {
    return response.data;
  }
};

const resetPass = async (data) => {
  const response = await axios.put(
    `${base_url}user/reset-password/${data.token}`,
    { password: data?.password }
  );
  if (response.data) {
    return response.data;
  }
};

const emptyCart = async (data) => {
  const response = await axios.delete(`${base_url}user/empty-cart`, data);
  if (response.data) {
    return response.data;
  }
};

export const authService = {
  register,
  login,
  endUserLogin,
  channeLogin,
  otp,
  endOtp,
  channelOtp,
  registerAccount,
  endUserRegister,
  loginAccount,
  getUserWislist,
  addToCart,
  getCart,
  removeProductFromCart,
  updateProductFromCart,
  createOrder,
  getUserOrders,
  updateUser,
  forgotPasswordToken,
  resetPass,
  emptyCart,
};